import L from 'leaflet'
import { useEffect } from 'react'
import { useMap } from 'react-leaflet'

import { useCompareDiagnoses } from '@/pages/diagnoses-compare/contexts/compare-diagnoses-context'

export function NavigateToField() {
  const map = useMap()
  const { zoomFieldId, selectedFields, setZoomFieldId } = useCompareDiagnoses()

  useEffect(() => {
    const field = selectedFields.features.find(
      (f) => f.properties.id === zoomFieldId,
    )

    if (field) {
      const bounds = L.geoJSON(field).getBounds()
      map.fitBounds(bounds)
      setZoomFieldId('')
    }
  }, [zoomFieldId, selectedFields])

  return null
}
